import { memo } from 'react'
import styled, { keyframes } from 'styled-components'

import MediaWrapper from '../shared/MediaWrapper'
import { CardWrapper, Media, Content } from '../shared/styled'

const TextRow = styled.div<{ length?: string; color?: string }>`
  display: block;
  width: 100%;
  height: 1em;
  margin-top: 0.7em;

  &:first-child {
    margin-top: 0;
  }

  &:after {
    content: ' ';
    display: inline-block;
    height: 1em;
    width: ${({ length }) => length || '100%'};
    background-color: ${({ color }) => color || '#eee'};
  }
`

const pulseAnimation = keyframes`
  0% {
    opacity: .6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: .6;
 }
`

export const PlaceholderCardWrapper = styled(CardWrapper)`
  animation: ${pulseAnimation} 1.5s infinite;
`

export const ListingContent = styled(Content)``

const PlaceholderDetails = styled.div`
  width: calc(100% / 1.61803398875);
  min-height: 100px;
`

export default memo(() => (
  <PlaceholderCardWrapper>
    <Media>
      <MediaWrapper />
    </Media>
    <Content as="div" style={{ paddingBottom: 0 }}>
      <PlaceholderDetails>
        <TextRow color="#ddd" length="97%" />
        <TextRow length="50%" />
      </PlaceholderDetails>
    </Content>
  </PlaceholderCardWrapper>
))
